
import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';

import Isvg from 'react-inlinesvg';



class Number extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }






    render() {
      //  console.log(this.props)
        //console.log(generateAlias("ćčććasd"))
        return (
                <>
                { this.props.label ? <label className={this.props.error ? "required" : ""}>{this.props.label}</label> : null } 
                <input className={this.props.error ? "required" : this.props.class} disabled={this.props.disabled} type='number' onChange={this.props.onChange} value={this.props.value} placeholder={this.props.placeholder}  min='1' max={this.props.max}/>
                </>
        );
    }
}

export default Number;